var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "card meta_data",
    attrs: {
      "id": "validators_meta"
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "staking_info"
  }, [_c('ValidatorStats'), _c('div', {
    staticClass: "peerinfo_cont"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "loading_cont"
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 16,
      "width": 2,
      "color": "#E84970",
      "indeterminate": ""
    }
  })], 1), _c('PeerStake', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.loading,
      expression: "!loading"
    }],
    attrs: {
      "data": _vm.stakes,
      "color-scale": _vm.stakesColorScale,
      "metric": 'stakePercent'
    }
  })], 1), _c('div', {
    staticClass: "peerinfo_cont"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "loading_cont"
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 16,
      "width": 2,
      "color": "#E84970",
      "indeterminate": ""
    }
  })], 1), _c('PeerCount', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.loading,
      expression: "!loading"
    }],
    attrs: {
      "data": _vm.versions,
      "color-scale": _vm.versionsColorScale,
      "metric": 'nodeCount'
    }
  })], 1)], 1)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("Validators")])]);
}]

export { render, staticRenderFns }